import React from 'react';
import { PaymentStatus } from '../../../types';
import './PaymentStatusBadge.css';

interface PaymentStatusBadgeProps {
  status: PaymentStatus;
  className?: string;
}

const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = (status: PaymentStatus) => {
    switch (status) {
      case 'pending':
        return { label: 'Pending', variant: 'warning' as const };
      case 'processing':
        return { label: 'Processing', variant: 'processing' as const };
      case 'succeeded':
        return { label: 'Paid', variant: 'success' as const };
      case 'failed':
        return { label: 'Failed', variant: 'danger' as const };
      case 'canceled':
        return { label: 'Cancelled', variant: 'danger' as const };
      case 'requires_action':
        return { label: 'Action Required', variant: 'warning' as const };
      case 'requires_confirmation':
        return { label: 'Confirmation Required', variant: 'warning' as const };
      case 'requires_payment_method':
        return { label: 'Payment Method Required', variant: 'warning' as const };
      default:
        return { label: 'Unknown', variant: 'neutral' as const };
    }
  };

  const { label, variant } = getStatusConfig(status);

  return (
    <span className={`payment-status-badge ${variant} ${className}`}>
      {label}
    </span>
  );
};

export default PaymentStatusBadge;
